var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForumDetailsFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.472,
    height: 20.773,
    viewBox: "0 0 20.472 20.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-flag",
    "data-name": "Icon awesome-flag",
    d: "M13.42,3.718C11.4,3.718,9.737,2.409,7.2,2.409a7.316,7.316,0,0,0-2.561.452,2.108,2.108,0,1,0-3.173.976V18.369a.9.9,0,0,0,.9.9h.6a.9.9,0,0,0,.9-.9V14.816a10.517,10.517,0,0,1,4.308-.833c2.017,0,3.683,1.309,6.219,1.309a7.88,7.88,0,0,0,4.611-1.538,1.2,1.2,0,0,0,.521-.992V3.612a1.2,1.2,0,0,0-1.712-1.092,10.959,10.959,0,0,1-4.4,1.2Z",
    transform: "translate(0.188 0.75)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForumDetailsFlag);
export default __webpack_public_path__ + "static/media/forum-details-flag.66deb7e0fa40cc60211fa6a8d3bdbe24.svg";
export { ForwardRef as ReactComponent };